import { api } from "../Apis/interceptor";
import { embedDashboard } from '@superset-ui/embedded-sdk';

export const dashboard = function (
  customerId,
  analyticsData,
  branch,
  service,
  user
) {
  return api.get("/api/v1/bidPerformanceDashboard/", {
    params: {
      customerId: customerId,
      businessUnit: analyticsData.businessUnit,
      sector: analyticsData.sector,
      region: analyticsData.region,
      timePeriod: analyticsData.timePeriod,
      branch_id: branch.branch_id,
      branch_key: branch.branch_key,
      service: service,
      user: user,
    },
  });
};

export const clientDashboard = function (
  cust_id,
  businessUnit,
  sector,
  region,
  timePeriod,
  service,
  user
) {
  return api.get("/api/v1/clientDashboard/", {
    params: {
      customerId: cust_id,
      businessUnit: businessUnit,
      sector: sector,
      region: region,
      timePeriod: timePeriod,
      service: service,
      user: user,
    },
  });
};

export const planningMetric = function (
  cust_id,
  businessUnit,
  sector,
  region,
  timePeriod,
  service,
  role
) {
  return api.get("/api/v1/planningMetric/", {
    params: {
      cust_id: cust_id,
      businessUnit: businessUnit,
      sector: sector,
      region: region,
      timePeriod: timePeriod,
      service: service,
      role: role,
    },
  });
};

export const planningMetricWinMrgn = function (
  cust_id,
  businessUnit,
  sector,
  region,
  timePeriod,
  service
) {
  return api.get("/api/v1/planningMetricWinMrgn/", {
    params: {
      cust_id: cust_id,
      businessUnit: businessUnit,
      sector: sector,
      region: region,
      timePeriod: timePeriod,
      service: service,
    },
  });
};

export const planningDashboard = function (
  cust_id,
  businessUnit,
  sector,
  region,
  timePeriod,
  periodsForPlanning,
  service,
  user
) {
  return api.get("/api/v1/planningDashboard/", {
    params: {
      cust_id: cust_id,
      businessUnit: businessUnit,
      sector: sector,
      region: region,
      timePeriod: timePeriod,
      periodsForPlanning: periodsForPlanning,
      service: service,
      user: user,
    },
  });
};
export const respDashboard = function (
  user_id,
  cust_id,
  businessUnit,
  sector,
  region,
  timePeriod,
  service
) {
  return api.get("/api/v1/respDashboard/", {
    params: {
      userId: user_id,
      customerId: cust_id,
      businessUnit: businessUnit,
      sector: sector,
      region: region,
      timePeriod: timePeriod,
      service: service,
    },
  });
};
export const respClientActions = function (
  user_id,
  cust_id,
  businessUnit,
  sector,
  region,
  timePeriod,
  service
) {
  return api.get("/api/v1/respClientActions/", {
    params: {
      userId: user_id,
      customerId: cust_id,
      businessUnit: businessUnit,
      sector: sector,
      region: region,
      timePeriod: timePeriod,
      service: service,
    },
  });
};
export const respRoleDashboard = function (
  user_id,
  user_role,
  cust_id,
  businessUnit,
  sector,
  region,
  timePeriod,
  service,
  access
) {
  return api.get("/api/v1/respRoleDashboard/", {
    params: {
      userId: user_id,
      user_role: user_role,
      customerId: cust_id,
      businessUnit: businessUnit,
      sector: sector,
      region: region,
      timePeriod: timePeriod,
      service: service,
      access: access,
    },
  });
};

export const getTopClients = function (
  cust_id,
  businessUnit,
  sector,
  region,
  timePeriod,
  service,
  winworkStage
) {
  return api.get("/api/v1/getTopClients", {
    params: {
      cust_id: cust_id,
      businessUnit: businessUnit,
      sector: sector,
      region: region,
      timePeriod: timePeriod,
      service: service,
      winworkStage: winworkStage,
    },
  });
};

export const getCoordinates = function (
  cust_id,
  businessUnit,
  sector,
  region,
  timePeriod,
  branch,
  service,
  user
) {
  return api.get("/api/v1/getCoordinates", {
    params: {
      cust_id: cust_id,
      businessUnit: businessUnit,
      sector: sector,
      region: region,
      timePeriod: timePeriod,
      branch_id: branch.branch_id,
      branch_key: branch.branch_key,
      service: service,
      user: user,
    },
  });
};

export const generateStageReport = function (cust_id) {
  window.open(`${process.env.REACT_APP_BACKEND_URL}/api/v1/generateStageReport?cust_id=${cust_id}`);
};

export const generateProjectReport = function (cust_id) {
  window.open(`${process.env.REACT_APP_BACKEND_URL}/api/v1/generateProjectReport?cust_id=${cust_id}`);
};

export const generatePptProjectReport = function (cust_id, client_id) {
  window.open(`${process.env.REACT_APP_BACKEND_URL}/api/v1/generatePptProjectReport?cust_id=${cust_id}&client_id=${client_id}`);
};

export const documentDashboard = function (
  user_id,
  cust_id,
  businessUnit,
  sector,
  region,
  timePeriod,
  service
) {
  return api.get("/api/v1/documentDashboard/", {
    params: {
      userId: user_id,
      customerId: cust_id,
      businessUnit: businessUnit,
      sector: sector,
      region: region,
      timePeriod: timePeriod,
      service: service,
    },
  });
};
/*Planning dashboard bottom table*/
export const currentPipeline = function (
  cust_id,
  businessUnit,
  sector,
  region,
  timePeriod,
  service,
  user
) {
  return api.get("/api/v1/currentPipeline/", {
    params: {
      cust_id: cust_id,
      businessUnit: businessUnit,
      sector: sector,
      region: region,
      timePeriod: timePeriod,
      service: service,
      user: user,
    },
  });
};

/*New Report*/
export const getOverviewReport = function (
  cust_id,
  selectedYear,
  timePeriod,
  token
) {
  window.open(
    "/api/v1/getOverviewReport?token=" +
    token +
    "&cust_id=" +
    cust_id +
    "&selectedYear=" +
    selectedYear +
    "&timePeriod=" +
    JSON.stringify(timePeriod)
  );
};

/* Target Planning Dashboard */
export const targetPlanningDashboard = function (
  subIndicators,
  dashboardFilter
) {
  return api.get("/api/v1/targetPlanningDashboard/", {
    params: {
      customerId: dashboardFilter.curCustomer,
      businessUnit: dashboardFilter.businessUnit,
      sector: dashboardFilter.sector,
      region: dashboardFilter.region,
      service: dashboardFilter.service,
      timePeriod: dashboardFilter.timePeriod,
      user: dashboardFilter.user,
      branch: dashboardFilter.branch,
      subIndicators: JSON.stringify(subIndicators),
    },
  });
};

export const targetPlanningMonthlyDashboard = function (
  subIndicatorId,
  subIndicatorName,
  dashboardFilter
) {
  return api.get("/api/v1/targetPlanningMonthlyDashboard/", {
    params: {
      customerId: dashboardFilter.curCustomer,
      businessUnit: dashboardFilter.businessUnit,
      sector: dashboardFilter.sector,
      region: dashboardFilter.region,
      service: dashboardFilter.service,
      timePeriod: dashboardFilter.timePeriod,
      user: dashboardFilter.user,
      branch: dashboardFilter.branch,
      subIndicatorId: subIndicatorId,
      subIndicatorName: subIndicatorName,
    },
  });
};

export const getSupersetUrl = function () {
  return api.get('/api/v1/getSupersetUrl')
}

async function fetchAccessToken(supersetApiUrl) {
  var body = {
    "username": "admin",
    "password": process.env.REACT_APP_SUPERSET_PASSWORD,
    "provider": "db",
    "refresh": true
  };

  var headers = { "Content-Type": "application/json" };

  try {
    const response = await fetch(`${supersetApiUrl}/login`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body),
    });
    if(response){
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
  }
}

async function fetchGuestToken(accessToken, current_customer_id, supersetApiUrl, dashboardId) {
  var customerId = "customer_id='" + `${current_customer_id}` + "'"
  var body = {
    "resources": [
      {
        "type": "dashboard",
        "id": dashboardId,
      }
    ],
    "rls": [{ "clause": customerId }],
    "user": {
      "username": "admin",
      "first_name": "Superset",
      "last_name": "Admin",
    }
  };

  var headers = {
    "Content-Type": "application/json",
    "Authorization": "Bearer " + accessToken,
  };

  try {
    const response = await fetch(`${supersetApiUrl}/guest_token/`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body),
    });
    if(response){
      const data = await response.json();
      return data.token;
    }
  } catch (error) {
    console.error(error);
  }
}

async function getGuestToken(supersetApiUrl, dashboardId, current_customer) {
  try {
    const accessTokenData = await fetchAccessToken(supersetApiUrl);
    if(accessTokenData){
      const guestToken = await fetchGuestToken(
        accessTokenData.access_token,
        current_customer,
        supersetApiUrl,
        dashboardId
      );
      return guestToken;
    }
  } catch (error) {
    console.error("Error getting guest token:", error);
  }
}

export const embedSupersetDashboard = async function (supersetUrl, supersetApiUrl, dashboardId, curCustomer) {
  try {
    const guestToken = await getGuestToken(supersetApiUrl, dashboardId, curCustomer);

    await embedDashboard({
      id: dashboardId,
      supersetDomain: supersetUrl,
      mountPoint: document.getElementById('dashboard-iframe'),
      fetchGuestToken: () => guestToken,
      dashboardUiConfig: {
        hideTitle: true,
        hideChartControls: true,
        hideTab: true,
      },
    });
  } catch (error) {
    console.error("Error embedding dashboard: ", error);
  }
}